import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { finalize } from 'rxjs/operators';
import { FunnelAnalyticsService } from '@app/ahoy-analytics/funnel-analytics.service';
import { PaymentGatewayTypes } from '../payment.types';

/** Extra, gateway-specific fields shown on the payment-status page (see payment-status.component.html). */
interface PaymentSummaryData {
  invoicePdfLink?: string;
  cardHolderNmae?: string;
  cardNumber?: string;
}

interface PaymentSummary {
  amount: number;
  bookingId: number;
  currency: string;
  data: PaymentSummaryData;
  id: number;
  isLBL: boolean;
  lblId: number;
  message: string;
  paymentDate: number;
  paymentGatewayType: number;
  paymentLink: string | null;
  referenceKey: string | number;
  status: string;
  statusId: number;
}

@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.scss'],
  standalone: false,
})
export class PaymentStatusComponent implements OnInit {
  isLoading = true;
  pSummary: PaymentSummary;
  isSuccess = false;
  dir: string;
  constructor(
    private route: ActivatedRoute,
    private paymentService: PaymentService,
    private router: Router,
    private funnelAnalytics: FunnelAnalyticsService,
  ) {}

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.dir = localStorage.getItem('html-dir');
    let transactionId = this.route.snapshot.paramMap.get('id');
    this.paymentService
      .getPaymentStatus(transactionId)
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((summary: PaymentSummary) => {
        this.pSummary = summary;
        this.isSuccess = summary.statusId == 2;

        let paymentMethod: string;
        if (summary.paymentGatewayType === PaymentGatewayTypes.Payfort) {
          paymentMethod = 'payfort';
        } else if (
          summary.paymentGatewayType === PaymentGatewayTypes.ApplePay
        ) {
          paymentMethod = 'applepay';
        } else if (summary.paymentGatewayType === PaymentGatewayTypes.Cashin) {
          paymentMethod = 'cashin';
        } else {
          paymentMethod = 'unknown';
        }
        if (this.isSuccess) {
          this.funnelAnalytics.paymentComplete(
            'payment',
            paymentMethod,
            summary.amount,
            summary.currency,
          );
        } else {
          this.funnelAnalytics.paymentFailed(
            'payment',
            paymentMethod,
            summary.message,
            summary.status,
          );
        }
      });
  }

  redirectTo() {
    if (this.pSummary.isLBL) {
      (window as unknown as { location: string }).location =
        `lc/${this.pSummary.lblId}/paymentsuccess`;
    } else {
      (window as unknown as { location: string }).location =
        `bookings/${this.pSummary.bookingId}`;
    }
  }
}
